import { Palette } from '@mui/material';
import colors from '@theme/colors';

export const MuiLink = (palette: Palette) => ({
  styleOverrides: {
    root: {
      '&.MuiLink-root ': {
        fontFamily: 'Proxima Nova',
        fontWeight: 700,
        lineHeight: '1',
      },
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: {
        // LIO's dark teal is ~2.5:1 on dark page palettes, so they use their accent color like other links
        color: palette.theme === 'lio' ? colors.SEAFOAM_SUPPLEMENTAL : palette.secondary.main,
      },
    },
  ],
});
